//
//
//
//
//
//


export default {
  data () {
    return {
      leftDrawerOpen: false
    }
  }
}
